import React, { useEffect } from "react";
import { Info } from "lucide-react";
import QRStudio from "@/components/QRStudio";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export default function Generator() {
  useEffect(() => {
    document.title = "QR Code Generator — CiteQR";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8 fade-in">
      <div className="max-w-3xl">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">QR Code Generator</h1>
        <p className="mt-3 text-base leading-relaxed text-slate-600">
          Create a free static QR code — no account required. Everything is generated privately in your browser and never stored on our servers.
        </p>
      </div>

      <Alert className="mt-6 border-slate-200 bg-slate-50" data-testid="static-info">
        <Info className="h-4 w-4" />
        <AlertTitle>These are static QR codes</AlertTitle>
        <AlertDescription className="text-slate-600">
          Static QR codes encode the final destination directly — they never expire and don't rely on a redirect server or tracking.
          (A <em>dynamic</em> QR code points to a changeable redirect link, but depends on that service staying online. CiteQR does not use dynamic redirects.)
          We can't guarantee an external site or document stays online permanently.
        </AlertDescription>
      </Alert>

      <div className="mt-8">
        <QRStudio downloadName="citeqr" />
      </div>
    </div>
  );
}
